import { _ } from "../../core/polyglot/polyglot.js";
import AbstractAgencyBillingStatus from "./AbstractAgencyBillingStatus.js";

let instance;

/**
 * An agency with this status is billed normally.
 */
export default class PayingAgencyBillingStatus extends AbstractAgencyBillingStatus {
	label() {
		return _("Paying");
	}

	static getType() {
		return "Paying";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
